var _div, _Refresh;
import AlertTriangle from '@crehana/compass.icons.outline/AlertTriangle';
import Refresh from '@crehana/compass.icons.outline/Refresh';
import { Button } from '@crehana/compass.ui/v2';
import { useLiveSessionsTranslation } from "../../hooks/useLiveSessionsTranslation";

// TODO: Define max retry attempts
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorLoadingSessions = function ErrorLoadingSessions(_ref) {
  var onRefresh = _ref.onRefresh;
  var _useLiveSessionsTrans = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-flex-col tw-gap-1.2 tw-items-center tw-justify-center tw-h-[420px] tw-rounded-[20px] tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-02",
    children: [_div || (_div = /*#__PURE__*/_jsx("div", {
      className: "tw-w-5.6 tw-h-5.6 tw-bg-alert-100 tw-p-[6px] tw-rounded-full tw-mx-auto",
      children: /*#__PURE__*/_jsx("div", {
        className: "tw-w-full tw-h-full tw-bg-alert-200 tw-rounded-full tw-flex tw-items-center tw-justify-center",
        children: /*#__PURE__*/_jsx(AlertTriangle, {
          size: 28,
          className: "tw-text-alert-500"
        })
      })
    })), /*#__PURE__*/_jsxs("div", {
      className: "tw-space-y-0.8",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "tw-font-subtitle5 tw-text-center",
        children: t('SESSIONS_LIST_ERROR_TITLE')
      }), /*#__PURE__*/_jsx("p", {
        className: "tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 tw-text-center",
        children: t('SESSIONS_LIST_ERROR_SUBTITLE')
      })]
    }), /*#__PURE__*/_jsxs(Button, {
      type: "submit",
      className: "tw-gap-0.8",
      onClick: onRefresh,
      children: [_Refresh || (_Refresh = /*#__PURE__*/_jsx(Refresh, {
        className: "tw-text-inherit",
        size: 16
      })), t('SESSIONS_LIST_ERROR_CTA')]
    })]
  });
};